import { render, staticRenderFns } from "./upload-vechic-dialog.vue?vue&type=template&id=2562e41a&scoped=true&"
import script from "./upload-vechic-dialog.vue?vue&type=script&lang=js&"
export * from "./upload-vechic-dialog.vue?vue&type=script&lang=js&"
import style0 from "./upload-vechic-dialog.vue?vue&type=style&index=0&id=2562e41a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2562e41a",
  null
  
)

export default component.exports